import MainPracticeScenario from './MainPracticeScenario';
import { constants } from '../../../../misc/helpers';

export default class MainPracticeScenarioSteps3And4 {
	constructor(private mainScenario: MainPracticeScenario, private onDone: () => void, public showFailedAar: () => void) {
	}

	start() {
		this.step1ShowBleedingControlKit();
	}

	private step1ShowBleedingControlKit() {
		var context = this;
		this.mainScenario.gameManager.UiManager.showUi(constants.InGameUINames.BleedoutTimer, {
			dispatch: this.mainScenario.gameManager.customData.dispatch,
			onTimeRanOut: () => {
				this.showFailedAar();
			},
			isActive: true
		});
		context.mainScenario.gameManager.UiManager.hideaAllUis();
		context.mainScenario.gameManager.UiManager.showUi(constants.InGameUINames.Feedback, {message: 'Open the bleeding control kit and select the pressure dressing.'});
		context.mainScenario.gameManager.UiManager.showUi(constants.InGameUINames.BleedingControlKit, {
			onSelectionChanged: (index: number) => {
				if(index === 0) {
					context.mainScenario.gameManager.UiManager.hideaAllUis();
					context.step2PressureDressingSelected();
				} else {
					context.step2PressureDressingNotSelected();
				}
			}
		});
	}

	private step2PressureDressingSelected() {
		var context = this;
		context.mainScenario.gameManager.UiManager.showSingleUi(constants.InGameUINames.BinaryQuestion, {
			title: 'Would you like to apply pressure to the wound?',
			correctButton: {
				title: 'Yes',
				onClick: () => context.mainScenario.onAnsweredCorrectly('MainPracticeScenarioSteps3And4.step2PressureDressingSelected', () => context.step3ApplyPressureYes())
			},
			incorrectButton: {
				title: 'No',
				onClick: () => context.step3ApplyPressureNo()
			}
		});
	}
	private step2PressureDressingNotSelected() {
		var context = this;
		context.mainScenario.gameManager.UiManager.hideaAllUis();
		this.mainScenario.showJITFeedback('This choice is incorrect', () => context.step1ShowBleedingControlKit());
	}

	private step3ApplyPressureYes() { 
		this.mainScenario.aarApplyPressureDressing = true;
		this.mainScenario.aarPressureDressing = true;
		var context = this;
		context.mainScenario.gameManager.UiManager.hideaAllUis();
			context.onDone();


		// context.mainScenario.playSequence('Steps3And4Cinematic', null, () => {
		// 	context.onDone();
		// });
	}

	private step3ApplyPressureNo() {
		var context = this;
		context.mainScenario.gameManager.UiManager.hideUi(constants.InGameUINames.BleedingControlKit);
		this.mainScenario.showJITFeedback('This choice is incorrect', () => context.step2PressureDressingSelected());
	}
}